import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ProduzioneDTF from "@/pages/ProduzioneDTF";
import GestioneDrop from "@/pages/GestioneDrop";
import GestioneMagazzino from "@/pages/GestioneMagazzino";
import Preventivatore from "@/pages/Preventivatore";
import Calcolatore from "@/pages/Calcolatore";
import Preventivi from "@/pages/Preventivi";
import StoricoVenditeRapide from "@/pages/StoricoVenditeRapide";
import RicercaOrdini from "@/pages/RicercaOrdini";
import ScannerBarcode from "@/pages/ScannerBarcode";
import ShopifySimulator from "@/pages/ShopifySimulator";
import GestioneUtenti from "@/pages/GestioneUtenti";
import CatalogoArticoli from "@/pages/CatalogoArticoli";
import RaccolteOrdini from "@/pages/RaccolteOrdini";
import RaccoltaDettaglio from "@/pages/RaccoltaDettaglio";
import PortaleRaccolte from "@/pages/portale/PortaleRaccolte";
import PortaleRaccolta from "@/pages/portale/PortaleRaccolta";
import { Loader2 } from "lucide-react";

const Spinner = () => (
  <div className="min-h-screen grid-bg flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-cyan-400" />
  </div>
);

// Pagine gestionale interno (admin + operatore). I responsabili vengono reindirizzati al portale.
const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "responsabile") return <Navigate to="/responsabile" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "responsabile") return <Navigate to="/responsabile" replace />;
  if (user.role !== "admin") return <Navigate to="/produzione" replace />;
  return children;
};

// Portale responsabile isolato
const ResponsabileRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "responsabile") return <Navigate to="/produzione" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/accesso-responsabile" element={<Login onlyResponsabile />} />
          <Route path="/produzione" element={<Protected><ProduzioneDTF /></Protected>} />
          <Route path="/drop" element={<Protected><GestioneDrop /></Protected>} />
          <Route path="/magazzino" element={<Protected><GestioneMagazzino /></Protected>} />
          <Route path="/preventivatore" element={<Protected><Calcolatore /></Protected>} />
          <Route path="/preventivi" element={<Protected><Preventivi /></Protected>} />
          <Route path="/vendita-rapida" element={<Protected><Preventivatore /></Protected>} />
          <Route path="/storico-vendite" element={<Protected><StoricoVenditeRapide /></Protected>} />
          <Route path="/ricerca-ordini" element={<Protected><RicercaOrdini /></Protected>} />
          <Route path="/raccolta-ordini" element={<Protected><RaccolteOrdini /></Protected>} />
          <Route path="/raccolta-ordini/:id" element={<Protected><RaccoltaDettaglio /></Protected>} />
          <Route path="/catalogo-articoli" element={<AdminRoute><CatalogoArticoli /></AdminRoute>} />
          <Route path="/scanner" element={<AdminRoute><ScannerBarcode /></AdminRoute>} />
          <Route path="/simulatore" element={<AdminRoute><ShopifySimulator /></AdminRoute>} />
          <Route path="/utenti" element={<AdminRoute><GestioneUtenti /></AdminRoute>} />
          <Route path="/responsabile" element={<ResponsabileRoute><PortaleRaccolte /></ResponsabileRoute>} />
          <Route path="/responsabile/raccolte/:id" element={<ResponsabileRoute><PortaleRaccolta /></ResponsabileRoute>} />
          <Route path="*" element={<Navigate to="/produzione" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
